import React, { FC, useMemo, useState } from 'react';
import Style from './appCheckboxInput.module.scss';
import clsx from 'clsx';
import { Tooltip } from 'uikit/tooltip/tooltip.component';

export type AppCheckboxInputVariant = 'primary' | 'destroy';

const isEllipsisActive = (e: HTMLElement | null) => {
  return e ? e.offsetWidth < e.scrollWidth : false;
};

export type AppCheckboxInputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  label?: string;
  readOnly?: boolean;
  labelClassName?: string;
  /** @default primary */
  variant?: AppCheckboxInputVariant;
  withEllipsis?: boolean;
};

export const AppCheckboxInput: FC<AppCheckboxInputProps> = ({
  disabled,
  readOnly,
  className,
  label,
  labelClassName,
  withEllipsis,
  variant = 'primary',
  ...rest
}) => {
  const [isEllipsis, setIsEllipsis] = useState(false);
  const labelWithEllipsis = useMemo(
    () => (
      <Tooltip
        text={label ?? ''}
        disabled={!isEllipsis}
        styles={'d-contents'}
        calloutContainerStyles={Style.tooltip}
        textStyles={Style.tooltipText}
        hostStyles={Style.tooltipHost}
      >
        <div className={Style.text} ref={(x) => setIsEllipsis(isEllipsisActive(x))}>
          {label}
        </div>
      </Tooltip>
    ),
    [isEllipsis, label],
  );

  return (
    <label data-disabled={disabled || readOnly} data-read-only={readOnly} className={clsx(Style.label, labelClassName)}>
      <input
        className={clsx(Style.input, className, {
          [Style.primary]: variant === 'primary',
          [Style.destroy]: variant === 'destroy',
        })}
        type={'checkbox'}
        disabled={disabled || readOnly}
        data-read-only={readOnly}
        {...rest}
      />
      {withEllipsis ? labelWithEllipsis : label}
    </label>
  );
};
